import React, { Fragment, useState, useEffect } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import $ from 'jquery';
import Tippy from '@tippyjs/react';

import addDays from 'date-fns/addDays';
import parse from 'date-fns/parse';
import CategoryAndFolderSelect from '../move/CategoryAndFolderSelector';

import useUsers from '../../hooks/useUsers';
import useCategories from '../../hooks/useCategories';

const TextInput = ({
    title, description, pageId, setTitle,
}) => {
    const isUpdateSuggestion = !!pageId;
    return (
        <Fragment>
            <label htmlFor="title" className="bold block col-12 mb1">What page should be created?</label>
            { isUpdateSuggestion
                ? (
                    <Fragment>
                        <input
                            name="title"
                            type="hidden"
                            id="title"
                            defaultValue={title}
                        />
                        <input
                            className="block col-12 mb2 field"
                            name="disabled-title"
                            type="text"
                            id="disabled-title"
                            defaultValue={title}
                            disabled
                        />
                    </Fragment>
                )
                : (
                    <input
                        className="block col-12 mb2 field"
                        name="title"
                        type="text"
                        id="title"
                        defaultValue={title || ''}
                        onChange={setTitle}
                    />
                )}

            <label htmlFor="description" className="bold block col-12 mb1">Add more details to your page request (optional)</label>
            <textarea className="block col-12 mb2 field" name="description" id="description" defaultValue={description || ''} />
        </Fragment>
    );
};

const USER_TYPE = 'App\\Models\\User';
const SLACK_USER_TYPE = 'App\\Models\\SlackUser';
const TOMORROW = addDays(new Date(), 1);

const LOADING_USER = [{ display_name: 'Loading users....', id: null }];

const SLACK_USER = 'slack_user';
const USER = 'user';

const getAssignableType = (selectedUser) => {
    if (!selectedUser) return '';

    return !Number.isInteger(selectedUser.id) ? SLACK_USER : USER;
};

const UserSelect = (props) => {
    const [selectedUser, setSelectedUser] = useState();
    const users = useUsers();
    const categories = useCategories();

    useEffect(() => {
        const { assignableId, assignableType, assignableSlackId } = props;
        if (users && assignableId) {
            const selectedUser = assignableType === USER_TYPE
                ? users.find(user => (user.id == assignableId))
                : users.find(user => user.slack_id == assignableSlackId);
            setSelectedUser(selectedUser);
        }
    }, [users]);

    const getCategoryOwnerIds = (categoryId) => categories && categories[categoryId] && categories[categoryId].owner_ids;

    const getOptions = () => {
        const { categoryId } = props;
        if (!users) return LOADING_USER;

        const categoryOwnerIds = getCategoryOwnerIds(categoryId);
        if (categoryOwnerIds && categoryOwnerIds.length > 0) {
            const ownerUsers = [];
            const nonOwnerUser = [];
            users.forEach((user) => {
                if (categoryOwnerIds.includes(user.id)) {
                    ownerUsers.push(user);
                } else {
                    nonOwnerUser.push(user);
                }
            });

            return ([
                {
                    label: 'Category Owners',
                    options: ownerUsers,
                },
                {
                    label: 'Users',
                    options: nonOwnerUser,
                },
            ]);
        }

        return users;
    };

    const assignableType = getAssignableType(selectedUser);
    const options = getOptions();

    return (
        <Fragment>
            <input id="assignable_type" name="assignable_type" type="hidden" value={assignableType} />
            <label htmlFor="assignable_id" className="bold block col-12 mb1">Who should create this page?</label>
            <Select
                id="assignable_id"
                name="assignable_id"
                className="block col-12 lg-col-6 field mb2"
                options={options}
                placeholder={users ? 'Anyone' : 'Loading...'}
                value={selectedUser}
                onChange={selectedUser => setSelectedUser(selectedUser)}
                getOptionValue={option => (option.id || option.slack_id)}
                getOptionLabel={option => option.display_name}
                isClearable
            />
        </Fragment>
    );
};

class TemplateSelect extends React.Component {
    state = { selectedTemplate: null };

    /*
     * EDITING THIS?
     * Please clean up UNSAFE_componentWillReceiveProps!
     * See: https://github.com/Tettra/tettra-wiki/issues/6002
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { templates, templateId } = nextProps;
        if (templates && templateId) {
            const selectedTemplate = templates.find(template => template.id == templateId);
            this.setState({ selectedTemplate });
        }
    }

    render() {
        const { templates } = this.props;
        const { selectedTemplate } = this.state;
        return (
            <Fragment>
                <label htmlFor="templateId" className="bold block col-12 mb1">Which template should this page use?</label>
                <Select
                    id="templateId"
                    name="templateId"
                    className="block col-12 lg-col-6 field"
                    options={templates || [{ title: 'Loading templates....', id: null }]}
                    placeholder={templates ? 'None' : 'Loading...'}
                    getOptionValue={option => option.id}
                    getOptionLabel={option => option.title}
                    value={selectedTemplate}
                    onChange={selectedTemplate => this.setState({ selectedTemplate })}
                    isClearable
                />
            </Fragment>
        );
    }
}

class SuggestionSchedulePicker extends React.Component {
    state = {
        scheduledAt: this.props.scheduleAt ? parse(this.props.scheduleAt, 'yyyy-MM-dd', TOMORROW) : null,
    };

    updateShowSchedule = () => {
        if (this.state.scheduledAt) {
            this.setState({ scheduledAt: null });
        } else {
            this.setState({ scheduledAt: TOMORROW });
        }
    };

    render() {
        const { scheduledAt } = this.state;

        return (
            <div className="mb2 mt2">
                <label htmlFor="schedule_at" className="bold block col-12 mb1">When should we send this request?</label>
                <label>
                    <input type="radio" value="Now" checked={!scheduledAt} onChange={this.updateShowSchedule} />
                    {' '}
Now
                </label>
                <br />
                <label className="mb3">
                    <input type="radio" value="On" checked={!!scheduledAt} onChange={this.updateShowSchedule} />
                    {' '}
Send on:
                    <DatePicker
                        id="schedule_at"
                        name="schedule_at"
                        className="block field ml1"
                        minDate={TOMORROW}
                        onChange={scheduledAt => this.setState({ scheduledAt })}
                        selected={this.state.scheduledAt}
                        disabled={!scheduledAt}
                    />
                </label>
            </div>
        );
    }
}

class SuggestionEditForm extends React.Component {
    state = {
        templates: null,
        title: this.props.title || '',
        categoryId: this.props.categoryId,
    };

    componentDidMount() {
        this.getTemplates();
    }

    getTemplates = () => $.get(`/api/teams/${window.teamDomain}/pages?templates=true`)
        .then(({ pages: templates }) => {
            this.setState({ templates });
        });

    setCategoryId = (categoryId) => this.setState({ categoryId });

    render() {
        const { templates, title, categoryId } = this.state;
        const {
            description,
            assignableId,
            assignableSlackId,
            assignableType,
            categoryId: initialCategoryId,
            folderId,
            templateId,
            scheduleAt,
            pageId,
        } = this.props;

        const edit = this.props.edit === undefined ? false : this.props.edit;
        const isUpdateSuggestion = !!pageId;
        const disableSubmitButton = !title;
        const buttonText = edit || window.location.pathname.includes('edit') ? 'Update page request' : 'Create page request';
        const shouldShowSchedule = edit ? false : !window.location.pathname.includes('edit') || scheduleAt;

        return (
            <Fragment>
                <div className="form-group">
                    <TextInput title={title} description={description} pageId={pageId} setTitle={({ target: { value: title } }) => this.setState({ title })} />
                    {
                        !isUpdateSuggestion
                        && (
                            <div className="rounded bg-light-gray p2 mt2">
                                <CategoryAndFolderSelect selectOnly smallWidth initialCategoryId={initialCategoryId} initialFolderId={folderId} setCategoryId={this.setCategoryId} />
                            </div>
                        )
                    }
                    { shouldShowSchedule && <SuggestionSchedulePicker scheduleAt={scheduleAt} /> }
                    <UserSelect assignableId={assignableId} assignableSlackId={assignableSlackId} assignableType={assignableType} categoryId={categoryId} />
                    { !isUpdateSuggestion && <TemplateSelect templates={templates} templateId={templateId} /> }
                </div>
                {
                    disableSubmitButton
                        ? (
                            <Tippy content="Missing title" placement="top">
                                <span className="btn btn-primary mt3 is-disabled">
                                    {buttonText}
                                </span>
                            </Tippy>
                        )
                        : <button id="save-settings" className="btn btn-primary mt3">{buttonText}</button>
                }
            </Fragment>
        );
    }
}

export default SuggestionEditForm;
